<template>
  <YzsDragDrawer
    v-model:visible="show"
    :title="fileInfo.title"
    :getContainer="getContainer"
    :width="800"
    :zIndex="1001"
  >
    <CommonViewer
      v-if="fileUrl"
      :url="fileUrl"
      :style="{ width: '100%', height: '800px' }"
    />
    <div v-else>{{ $t("noAttachment") }}</div>
  </YzsDragDrawer>
</template>
<script lang="ts" setup>
import { reactive, ref } from "vue";
import CommonViewer from "./commonViewer.vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const show = ref(false);
const fileUrl = ref("");
const fileInfo = reactive({
  title: "查看附件",
});

function viewer(url: string, title: string) {
  fileUrl.value = url;
  show.value = true;
  if (!!title) {
    fileInfo.title = title;
  }
}
function getContainer() {
  //兼容不适用通用组件的情况
  if (document.querySelector(".porta-renderer-wrapper")) {
    return document.querySelector(".porta-renderer-wrapper");
  }
  if (document.querySelector(".main__container")) {
    return document.querySelector(".main__container");
  }
  return false;
}

defineExpose({
  viewer,
});
</script>
